module.exports = __webpack_public_path__ + "static/Appointment Letter-058901a4bfa8b8cc844421fd651b063c.jpg";